import script from "./EventCard.vue?vue&type=script&setup=true&lang=js"
export * from "./EventCard.vue?vue&type=script&setup=true&lang=js"

import "./EventCard.vue?vue&type=style&index=0&id=490d8e3e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-490d8e3e"]])

export default __exports__